<template>
  <Head title="Results - Initiative Details" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <initiative-details :initiative="initiative" :client="client"></initiative-details>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  initiative: Object,
  client: Object
});
</script>

